import { useQuery, useMutation, useQueryClient } from 'react-query';
import { can } from '../../permissions';
import { usePortal } from './hooks';
import { organizationRequest } from '../MinhaOrganizadora/services';
import { savePositionConfiguration } from './registrationConfiguration';

export default function useRegistrationConfiguration(selection, source) {
  const { faculdade, token, user } = usePortal();
  const cache = useQueryClient();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const query = useQuery(
    ['portal-position', user?.id, faculdade, selection.ontest_faculdade_id, source.id],
    () =>
      organizationRequest(
        token,
        `organizadora/${faculdade}/seletivos/${selection.ontest_faculdade_id}/cargos/${source.id}/inscricoes`
      ).then((response) => response.data),
    { retry: false }
  );
  const save = useMutation(
    ({ position, saved }) => {
      if (!allowed) throw new Error('Você não possui permissão para editar esta configuração.');
      return savePositionConfiguration({
        organization: faculdade,
        token,
        selection,
        position,
        saved,
      });
    },
    {
      onSettled: () =>
        Promise.all([
          cache.invalidateQueries(['portal', faculdade, user?.id]),
          cache.invalidateQueries(['portal-position', user?.id, faculdade]),
        ]),
    }
  );
  return { ...query, allowed, save };
}
